import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import apiClient from "../../../AppClient";
import { Container, Table, Alert, Spinner } from "react-bootstrap";
import {CURRENCY} from "../../../constants/Constants";
const SaleView = () => {
  const { id } = useParams(); // Get the sales ID from the URL
  const [transaction, setTransaction] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch sales transaction details
  const fetchTransaction = async () => {
    setLoading(true);
    try {
      const response = await apiClient.get(`/transactions/sales/${id}/`);
      setTransaction(response.data);
      setError(null);
    } catch (error) {
      setError(error.response?.data?.detail || "Failed to fetch transaction details.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTransaction();
  }, [id]);

  if (loading) {
    return (
      <Container className="text-center mt-5">
        <Spinner animation="border" role="status" variant="primary">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </Container>
    );
  }

  if (error) {
    return (
      <Container className="mt-5">
        <Alert variant="danger">{error}</Alert>
      </Container>
    );
  }

  if (!transaction) {
    return (
      <Container className="mt-5">
        <Alert variant="warning">No transaction data found.</Alert>
      </Container>
    );
  }

  return (
    <Container style={{ direction: "rtl", textAlign: "right", padding: "20px", fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif" }}>
      <h1 style={{ color: "#1D4D2C", marginBottom: "20px" }}>تفاصيل فاتورة البيع</h1>

      {/* Customer Details */}
      <Table striped bordered hover responsive className="mb-4">
        <thead>
          <tr>
            <th colSpan="2" className="text-center bg-success text-white">
              معلومات العميل
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><strong>اسم العميل:</strong></td>
            <td>{transaction.customer.name}</td>
          </tr>
          <tr>
            <td><strong>نوع العميل:</strong></td>
            <td>{transaction.customer.customer_type}</td>
          </tr>
          <tr>
            <td><strong>رقم الهاتف:</strong></td>
            <td>{transaction.customer.phone}</td>
          </tr>
          <tr>
            <td><strong>تاريخ آخر شراء:</strong></td>
            <td>{transaction.customer.last_purchase_date || "غير متوفر"}</td>
          </tr>
          <tr>
            <td><strong>إجمالي المشتريات:</strong></td>
            <td>{transaction.customer.total_purchase_value || "0.00"} {CURRENCY} </td> 
          </tr>
          <tr>
            <td><strong>المبلغ المتبقي:</strong></td>
            <td>{transaction.customer.remaining_balance} {CURRENCY}</td>
          </tr>
        </tbody>
      </Table>

      {/* Sales Details */}
      <Table striped bordered hover responsive className="mb-4">
        <thead>
          <tr>
            <th colSpan="2" className="text-center bg-success text-white">
              معلومات الفاتورة
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><strong>رقم الفاتورة:</strong></td>
            <td>{transaction.invoice_number}</td>
          </tr>
          <tr>
            <td><strong>تاريخ الفاتورة:</strong></td>
            <td>{transaction.invoice_date}</td>
          </tr>
          <tr>
            <td><strong>وقت الفاتورة:</strong></td>
            <td>{transaction.invoice_time}</td>
          </tr>
          <tr>
            <td><strong>طريقة الدفع:</strong></td>
            <td>{transaction.payment_method}</td>
          </tr>
          <tr>
            <td><strong>عدد الأقساط:</strong></td>
            <td>{transaction.number_of_installments}</td>
          </tr>
          <tr>
            <td><strong>قيمة الخصم:</strong></td>
            <td>{transaction.discount_value} {CURRENCY}</td>
          </tr>
          <tr>
            <td><strong>إجمالي الفاتورة:</strong></td>
            <td>{transaction.total_price} {CURRENCY}</td>
          </tr>
        </tbody>
      </Table>

      {/* Sales Items */}
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th colSpan="6" className="text-center bg-success text-white">
              العناصر المباعة
            </th>
          </tr>
          <tr>
            <th>#</th>
            <th>اسم المنتج</th>
            <th>الكمية</th>
            <th>سعر البيع</th>
            <th>إجمالي السعر</th>
          </tr>
        </thead>
        <tbody>
          {transaction.sales_items.map((item, index) => (
            <tr key={item.id}>
              <td>{index + 1}</td>
              <td>{item.product.name}</td>
              <td>{item.quantity}</td>
              <td>{item.sale_price} {CURRENCY}</td>
              <td>{item.total_price} {CURRENCY}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Container>
  );
};

export default SaleView;